export default __webpack_public_path__ + "static/img01-e6dc3b1ca4acf806ad0dee4c9cfda953.jpg";